module.exports = __webpack_public_path__ + "img/success-mark.ee7d321a.svg";